import NavigationListItem from './components/NavigationListItem';
import styles from './Sidebar.module.css';

const Sidebar = () =>
{
	return (
		<div className={styles.sidebar}>
			<div className={styles.navigation}>
				<NavigationListItem label='Mods' path='/mods' />
				<NavigationListItem label='Scenarios' path='/scenarios' />
				<NavigationListItem label='Servers' path='/servers' />
			</div>
		</div>
	);
};

export default Sidebar;